export default "/assets/images/mila-feed-02-thumbnail.jpg?6558f7e0512c40f716247805c0858f0b";